import React from "react";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as List from "../../../../../../../common-deprecated/styles/v2/toyota/globals/List";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { reserveCar } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import Container from "../../common/styles/Container";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { MODAL_RESERVE_TERMS } from "../../../../utils/modalConstants";
import DisclaimerContainer from "../../common/disclaimer/DisclaimerContainer";
import ReservePanel from "./ReservePanel";
import * as Styles from "./styles/Reserve";
import useReserve from "../../../../hooks/buy/useReserve";
import { trackCtaCheckout } from "../../../../utils/tracking";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const ReserveView = (): JSX.Element => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const { labels, enableTermsConditions } = useReserve();

    const [reserveDescriptionLabel, reserveDescriptionMonthlyLabel] = useBnbOptionalLabel([
        "reserveDescription",
        "reserveDescriptionMonthly",
    ]);
    const description =
        financeOption === "monthly" && reserveDescriptionMonthlyLabel
            ? "reserveDescriptionMonthly"
            : reserveDescriptionLabel
              ? "reserveDescription"
              : null;

    const onReserveCar = (): void => {
        trackCtaCheckout(NavStep.Reserve, "online-retailing-checkout-reservation");
        dispatch(reserveCar());
    };
    const openConditionsModal = (event: React.MouseEvent): void => {
        event.preventDefault();
        dispatch(showModal({ type: MODAL_RESERVE_TERMS }));
    };

    return (
        <>
            <Styles.Wrapper hasBackground>
                <Container maxWidth={{ _: "none", lg: 750 }}>
                    <Flex.Row>
                        <Flex.Col width={{ _: 1, lg: 1 / 2 }}>
                            <Styles.Title>
                                <BnbLabel
                                    label={financeOption === "cash" ? "reserveTitle" : "reserveTitleMonthly"}
                                    fallbackLabel="reserveTitle"
                                />
                            </Styles.Title>

                            {description && (
                                <Styles.Description>
                                    <BnbLabel label={description} useHTML />
                                </Styles.Description>
                            )}

                            <List.BulletList>
                                {labels.map((item) => (
                                    <List.BulletListItem key={item.icon}>
                                        {item.extraInfo || item.extraText ? (
                                            <>
                                                <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                                <Popover showOnClick content={item.extraInfo} />
                                                <span dangerouslySetInnerHTML={{ __html: item.extraText || "" }} />
                                            </>
                                        ) : (
                                            <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                        )}
                                    </List.BulletListItem>
                                ))}
                            </List.BulletList>

                            {enableTermsConditions && (
                                <Button.Link onClick={openConditionsModal}>
                                    <Text.Button>
                                        <BnbLabel
                                            label={
                                                financeOption === "cash"
                                                    ? "reserveTermsConditionsLink"
                                                    : "reserveTermsConditionsLinkMonthly"
                                            }
                                            fallbackLabel="reserveTermsConditionsLink"
                                        />
                                    </Text.Button>
                                </Button.Link>
                            )}
                        </Flex.Col>

                        <Styles.Sidebar width={{ _: 1, lg: 1 / 2 }}>
                            <ReservePanel reserveCar={onReserveCar} />
                        </Styles.Sidebar>
                    </Flex.Row>
                </Container>
            </Styles.Wrapper>

            <Styles.Wrapper hasBackground>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer />
                </Container>
            </Styles.Wrapper>
        </>
    );
};

export default ReserveView;
